var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq31(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.571484,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8078,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.3953,
    y1: 12.1824,
    x2: 49.6316,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.721462,
    y1: 49.8543,
    x2: 11.9578,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.1574,
    y1: 38.6199,
    x2: 49.3938,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.483616,
    y1: 0.944118,
    x2: 11.7199,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.868 22.524C20.9333 21.6747 21.26 21.0073 21.848 20.522C22.4453 20.0273 23.2153 19.78 24.158 19.78C24.7833 19.78 25.32 19.892 25.768 20.116C26.216 20.34 26.552 20.648 26.776 21.04C27.0093 21.4227 27.126 21.8567 27.126 22.342C27.126 22.93 26.9533 23.4387 26.608 23.868C26.2627 24.2973 25.7727 24.5633 25.138 24.666V24.736C25.8007 24.8667 26.328 25.156 26.72 25.604C27.112 26.0427 27.308 26.6213 27.308 27.34C27.308 28.1427 27.0373 28.8007 26.496 29.314C25.964 29.818 25.1893 30.07 24.172 30.07C23.2013 30.07 22.4033 29.818 21.778 29.314C21.1527 28.8007 20.7933 28.0773 20.7 27.144H21.652C21.736 27.7693 21.9973 28.278 22.436 28.67C22.8747 29.0527 23.4533 29.244 24.172 29.244C24.8813 29.244 25.4227 29.0573 25.796 28.684C26.1787 28.3107 26.37 27.8347 26.37 27.256C26.37 25.8373 25.348 25.128 23.304 25.128H22.996V24.302H23.318C25.222 24.302 26.174 23.6813 26.174 22.44C26.174 21.8987 25.9967 21.4647 25.642 21.138C25.2873 20.802 24.7833 20.634 24.13 20.634C23.4953 20.634 22.968 20.802 22.548 21.138C22.1373 21.4647 21.8947 21.9267 21.82 22.524H20.868ZM28.6235 20.844V19.962H31.0035V30H30.0095V20.844H28.6235Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq31);
export default __webpack_public_path__ + "static/media/fq31.e3d84b2ecc37c8ef93e608549bd7b73a.svg";
export { ForwardRef as ReactComponent };